export default __webpack_public_path__ + "static/media/tactical adventures.e5f3f700.jpg";